

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api';
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// ── Helper: 2 onluğa yuvarlaqlaşdır ──────────────────────────
const round2 = (num) => parseFloat(parseFloat(num).toFixed(2))

// export const get_seller_payemt_details = createAsyncThunk(
//     'payment/get_seller_payemt_details',
//     async (sellerId, { rejectWithValue, fulfillWithValue, getState }) => {
//         // const token = getState().auth.token
//         // const config = { headers: { 'Authorization': `Bearer ${token}` } }
//         try {
//             const { data } = await axios.get(`${api_url}/api/payment/seller-payment-details/${sellerId}`, { withCredentials: true } )
//             return fulfillWithValue(data)
//         } catch (error) {
//             return rejectWithValue(error.response.data)
//         }
//     }
// )
export const get_seller_payemt_details = createAsyncThunk(
    'payment/get_seller_payemt_details',
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            // sellerId varsa — admin, yoxdursa — seller
            const url = sellerId
                ? `${api_url}/api/payment/seller-payment-details/${sellerId}`
                : `${api_url}/api/payment/my-payment-details`

            const { data } = await axios.get(url, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const send_withdrowal_request = createAsyncThunk(
    'payment/send_withdrowal_request',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await api.post(`/payment/withdrowal-request`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_payment_request = createAsyncThunk(
    'payment/get_payment_request',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/payment/request`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const confirm_payment_request = createAsyncThunk(
    'payment/confirm_payment_request',
    async (paymentId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await api.post(`/payment/request-confirm`, { paymentId }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const add_bank_info = createAsyncThunk(
    'payment/add_bank_info',
    async (bankData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = { headers: { 'Authorization': `Bearer ${token}` } };
        try {
            const { data } = await api.post(`/payment/add-bank-info`, bankData, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_bank_info = createAsyncThunk(
    'payment/get_bank_info',
    async (_, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = { headers: { 'Authorization': `Bearer ${token}` } };
        try {
            const { data } = await axios.get(`${api_url}/api/payment/get-bank-info`, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_all_bank_info_admin = createAsyncThunk(
    'payment/get_all_bank_info_admin',
    async ({ status, page, limit }, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = { headers: { 'Authorization': `Bearer ${token}` } };
        try {
            const { data } = await axios.get(
                `${api_url}/api/admin/bank-info/all?status=${status}&page=${page}&limit=${limit}`,
                { withCredentials: true }
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const approve_bank_info = createAsyncThunk(
    'payment/approve_bank_info',
    async (bankInfoId, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = { headers: { 'Authorization': `Bearer ${token}` } };
        try {
            const { data } = await api.post(`/admin/bank-info/approve`, { bankInfoId }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const reject_bank_info = createAsyncThunk(
    'payment/reject_bank_info',
    async ({ bankInfoId, reason }, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = { headers: { 'Authorization': `Bearer ${token}` } };
        try {
            const { data } = await api.post(`/admin/bank-info/reject`, { bankInfoId, reason }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);



export const PaymentReducer = createSlice({
    name: 'payment',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        pendingWithdrows: [],
        successWithdrows: [],
        totalAmount: 0,
        withdrowAmount: 0,
        pendingAmount: 0,
        availableAmount: 0,
        bankInfo: null,
        allBankInfos: [],
        totalBankInfos: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder

        // ── get_seller_payemt_details ──────────────────────────────
        .addCase(get_seller_payemt_details.fulfilled, (state, { payload }) => {
            state.pendingWithdrows  = payload.pendingWithdrows
            state.successWithdrows  = payload.successWithdrows
            // ✅ round2 ilə float precision problemini aradan qaldır
            state.totalAmount       = round2(payload.totalAmount)
            state.availableAmount   = round2(payload.availableAmount)
            state.withdrowAmount    = round2(payload.withdrowAmount)
            state.pendingAmount     = round2(payload.pendingAmount)
        })

        // ── send_withdrowal_request ────────────────────────────────
        .addCase(send_withdrowal_request.pending, (state) => {
            state.loader = true
        })
        .addCase(send_withdrowal_request.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.message
        })
        .addCase(send_withdrowal_request.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage   = payload.message
            state.pendingWithdrows = [...state.pendingWithdrows, payload.withdrowal]
            // ✅ round2 ilə 13.95 - 13 = 0.9499... problemi həll olur → 0.95
            state.availableAmount  = round2(state.availableAmount - payload.withdrowal.amount)
            // ✅ += (köhnə kod = idi, hər sorğuda sıfırlanırdı)
            state.pendingAmount    = round2(state.pendingAmount + payload.withdrowal.amount)
        })

        // ── get_payment_request ────────────────────────────────────
        .addCase(get_payment_request.fulfilled, (state, { payload }) => {
            state.pendingWithdrows = payload.withdrowalRequest
        })

        // ── confirm_payment_request ────────────────────────────────
        .addCase(confirm_payment_request.pending, (state) => {
            state.loader = true
        })
        .addCase(confirm_payment_request.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.message
        })
        .addCase(confirm_payment_request.fulfilled, (state, { payload }) => {
            // ✅ DÜZƏLDİLDİ: köhnə kod yalnız pending-dən silirdi
            // İndi həm silir, həm successWithdrows-a əlavə edir
            const confirmedItem = state.pendingWithdrows.find(r => r._id === payload.payment._id)

            state.loader           = false
            state.successMessage   = payload.message
            state.pendingWithdrows = state.pendingWithdrows.filter(r => r._id !== payload.payment._id)

            if (confirmedItem) {
                // ✅ Status 'success' olaraq successWithdrows-a əlavə et
                state.successWithdrows = [
                    ...state.successWithdrows,
                    { ...confirmedItem, status: 'success' }
                ]
                // ✅ Pending azal, withdraw artır
                state.pendingAmount  = round2(Math.max(0, state.pendingAmount - confirmedItem.amount))
                state.withdrowAmount = round2(state.withdrowAmount + confirmedItem.amount)
            }
        })

        // ── add_bank_info ──────────────────────────────────────────
        .addCase(add_bank_info.pending, (state) => {
            state.loader = true;
        })
        .addCase(add_bank_info.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
            state.bankInfo = payload.bankInfo;
        })
        .addCase(add_bank_info.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.message || 'Xəta baş verdi';
        })

        // ── get_bank_info ──────────────────────────────────────────
        .addCase(get_bank_info.fulfilled, (state, { payload }) => {
            state.bankInfo = payload.bankInfo;
        })

        // ── get_all_bank_info_admin ────────────────────────────────
        .addCase(get_all_bank_info_admin.pending, (state) => {
            state.loader = true;
        })
        .addCase(get_all_bank_info_admin.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.allBankInfos   = payload.bankInfos || payload.data || [];
            state.totalBankInfos = paginationTotal(payload, 'total');
        })

        // ── approve_bank_info ──────────────────────────────────────
        .addCase(approve_bank_info.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message;
        })

        // ── reject_bank_info ───────────────────────────────────────
        .addCase(reject_bank_info.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message;
        });
    }
})

export const { messageClear } = PaymentReducer.actions
export default PaymentReducer.reducer
